/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface BulkTimeseriesRain
 */
export interface BulkTimeseriesRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   *
   */
  file?: any;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  epsgCode?: number;
}

/**
 * Check if a given object implements the BulkTimeseriesRain interface.
 */
export function instanceOfBulkTimeseriesRain(value: object): value is BulkTimeseriesRain {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  return true;
}

export function BulkTimeseriesRainFromJSON(json: any): BulkTimeseriesRain {
  return BulkTimeseriesRainFromJSONTyped(json, false);
}

export function BulkTimeseriesRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkTimeseriesRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    file: json["file"] == null ? undefined : json["file"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    epsgCode: json["epsg_code"] == null ? undefined : json["epsg_code"],
  };
}

export function BulkTimeseriesRainToJSON(json: any): BulkTimeseriesRain {
  return BulkTimeseriesRainToJSONTyped(json, false);
}

export function BulkTimeseriesRainToJSONTyped(
  value?: Omit<
    BulkTimeseriesRain,
    "url" | "id" | "uid" | "simulation" | "state" | "stateDetail"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    file: value["file"],
    epsg_code: value["epsgCode"],
  };
}
